import { useMemo } from 'react';
import { getFilteredRowData } from './utils';

export const useFilteredRowData = (rowData, topXCount, metricForTopX) => {
    return useMemo(() => {
        return getFilteredRowData(rowData, topXCount, metricForTopX);
    }, [rowData, topXCount, metricForTopX]);
};
